<div *ngIf="character" class="d-flex justify-content-between h-100">
  <div class="d-flex flex-column justify-content-center name-section ml-3">
    <input class="mt-2 ml-3 name-input" [(ngModel)]="character.characterName">
  </div>
  <div class="card character-info mr-3 mt-3">
    <div class="d-flex justify-content-start flex-wrap w-100 mt-1 pl-2 pr-2 pb-2">
      <div class="character-info-field">
        <div class="text-muted text-left small">Race</div>
        <div class="border-bottom text-md-left">{{character.race}}</div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Classes</div>
        <div class="border-bottom text-md-left">
          <div class="d-flex">
            <span *ngFor="let _class of classes | keyvalue" class="mr-1">{{_class.key}} ({{_class.value}})</span>
          </div>
        </div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Alignment</div>
        <div *ngIf="character.alignment" class="border-bottom text-md-left">{{character.alignment}}</div>
        <div *ngIf="!character.alignment" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Background</div>
        <div *ngIf="character.background" class="border-bottom text-md-left">{{character.background}}</div>
        <div *ngIf="!character.background" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Backstory</div>
        <div *ngIf="character.backStory" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.backStory.length > 18 ? character.backStory.substring(0, 18) + '...' : character.backStory}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><p>{{character.backStory}}</p></div>
        </div>
        <div *ngIf="!character.backStory" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Personality Traits</div>
        <div *ngIf="character.personalityTraits" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.personalityTraits.length > 18 ? character.personalityTraits.substring(0, 18) + '...' :
            character.personalityTraits}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><p>{{character.personalityTraits}}</p></div>
        </div>
        <div *ngIf="!character.personalityTraits" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Ideals</div>
        <div *ngIf="character.ideals" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.ideals.length > 1 ? character.ideals.substring(0, 18) + '...' : character.ideals}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><p>{{character.ideals}}</p></div>
        </div>
        <div *ngIf="!character.ideals" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Bonds</div>
        <div *ngIf="character.bonds" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.bonds && character.bonds.length > 18 ? character.bonds.substring(0, 18) + '...' :
            character.bonds}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><p>{{character.bonds}}</p></div>
        </div>
        <div *ngIf="!character.bonds" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Flaws</div>
        <div *ngIf="character.flaws" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.flaws && character.flaws.length > 18 ? character.flaws.substring(0, 18) + '...' :
            character.flaws}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><p>{{character.flaws}}</p></div>
        </div>
        <div *ngIf="!character.flaws" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
      <div class="character-info-field">
        <div class="text-muted text-left small">Languages</div>
        <div *ngIf="character.languages" class="border-bottom text-md-left" ngbDropdown>
          <div class="clickable" ngbDropdownToggle>
            {{character.languages[0] + '...'}}</div>
          <div class="custom-scrollbar dropdown-menu p-2" ngbDropdownMenu><span *ngFor="let lang of character.languages">
            {{lang + ", "}}</span></div>
        </div>
        <div *ngIf="!character.languages" class="border-bottom"><span class="opacity-0">l</span></div>
      </div>
    </div>
  </div>
</div>
